

import React from 'react';
import PropTypes from 'prop-types';
import {getText, renderMarkdown} from 'helpers/text-helper';
import GameProgress from 'components/ui/game-progress/game-progress';
import Button from 'components/ui/button/button';
import './game-results-intro.scss';

const GameResultsIntro = ({languageId, deviceInfo, goToPage}) => {
	return (
		<div className={'GameResultsIntro ' + deviceInfo.orientation}>
			{/* Home btn */}
			<div className="GameResultsIntro-homeBtn" onClick={() => {goToPage('settings');}} />
			
			{/* Content */}
			<div className="GameResultsIntro-content">
				{/* Game progress */}
				<GameProgress 
					languageId={languageId}
					progressStepId={'results'}
					deviceInfo={deviceInfo}
				/>

				{/* Title & text */}
				<div className='GameResultsIntro-title'>
					<span>{getText('pages_gameResultsIntroTitle', languageId)}</span>
				</div>
				<div className='GameResultsIntro-text'>
					{renderMarkdown(getText('pages_gameResultsIntroText', languageId))}
				</div>
			</div>

			<div className="GameResultsIntro-backBtn">
				<Button 
					classes={['orange', 'fullHeight']}
					text={getText('general_back', languageId)}
					onClick={() => {goToPage('game-status');}}
				/>
			</div>
			<div className="GameResultsIntro-nextBtn">
				<Button 
					classes={['orange', 'next', 'fullHeight']}
					text={getText('general_next', languageId)}
					onClick={() => {goToPage('game-results');}}
				/>
			</div>
		</div>
	);
};

GameResultsIntro.propTypes = {
	languageId: PropTypes.string.isRequired,
	deviceInfo: PropTypes.object.isRequired,
	goToPage: PropTypes.func.isRequired
};

export default GameResultsIntro;